const loadData = ({fetch, uri, beforeFetch, afterFetch, state, fetchProps}) => {
  let beforeState;
  if (beforeFetch) {
    let resp = beforeFetch({
      state,
      uri,
      fetchProps,
    });

    if (resp) {
      if (resp.uri) {
        uri = resp.uri;
      }
      if (resp.state) {
        beforeState = resp.state;
      }
    }
  }

  return {
    beforeState,
    afterState: () => {
      return fetch({uri})
        .then(async result => {
          if (afterFetch) {
            let resultState = await afterFetch({
              state,
              fetchProps,
              result,
              uri,
            });
            if (resultState && resultState.state) {
              return resultState.state;
            }
          } else if (result) {
            return result;
          }
        })
        .catch(e => {
          console.error('Error in DataLoader while loadData', e.message);
          // ToDo handle error
        });
    },
  };
};

export {loadData};
